import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  public isLoading = new BehaviorSubject<boolean>(false);

  private asyncDownloadCount = 0;

  beginAsyncDownload(): void {
    this.asyncDownloadCount++;
    this.isLoading.next(true);
  }

  endAsyncDownload(): void {
    this.asyncDownloadCount = Math.max(0, this.asyncDownloadCount - 1);
    if (this.asyncDownloadCount === 0) {
      this.isLoading.next(false);
    }
  }

  isAsyncDownloadActive(): boolean {
    return this.asyncDownloadCount > 0;
  }
}
